import { Parts, PartType } from "@/utils/parts";
import { useCallback, useMemo } from "react";

export function useParseText( text: string ) {
    const parts = useMemo( () => {
        return new Parts( text || "" ).parts;
    }, [ text ] );
    const renderParts = useCallback( () => {
        return parts.map( ( part, index ) => {
            if ( part.type === PartType.link ) {
                return (
                    <a
                        key={index}
                        href={part.text}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-data-primary hover:underline break-all"
                    >
                        {part.text}
                    </a>
                );
            }
            if ( part.type === PartType.mention ) {
                return (
                    <span key={index} className="text-data-primary break-all">
                        {part.text}
                    </span>
                );
            }
            return <span key={index} className="break-all">{part.text}</span>;
        } );
    }, [ parts ] );
    return {
        renderParts,
    };
}
